import styled from "styled-components";

import { motion } from "@enkor/framer-motion";

import { Typo } from "@enkor/design/components";
import { grayScale, pink } from "@enkor/design/colors";

export const Container = styled.div`
  min-height: 100vh;
  padding-bottom: 60px;
`;

export const UserInfoContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: ${grayScale[100]};
  border-radius: 50px;
  padding: 8px 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  cursor: pointer;
`;

export const ProfileImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  background-color: ${grayScale[100]};
`;

export const UserName = styled(Typo.Text)`
  color: ${grayScale.white};
  margin: 0;
`;

export const LoginButton = styled(motion.button)`
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: ${pink.main};
  color: ${grayScale.white};
  border: none;
  border-radius: 50px;
  padding: 8px 16px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 10;

  &:hover {
    background-color: ${pink[300]};
  }

  &:active {
    background-color: ${pink[200]};
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  text-align: center;
  margin: 1rem 0;
`;

export const EmptyText = styled.p`
  text-align: center;
  color: ${grayScale.main};
  padding: 2rem 1rem;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const CreateButton = styled.button`
  background-color: #4299e1;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #3182ce;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.3);
  }
`;

export const NoticeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
`;

export const NoticeText = styled(Typo.Text)`
  color: ${grayScale.white};
`;

export const ProjectList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  list-style: none;
  padding: 0;
`;

export const ProjectItem = styled.li`
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  transition:
    transform 0.2s,
    box-shadow 0.2s;
  padding: 16px;
  gap: 16px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
`;

export const ProjectMainContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

export const ProjectContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
`;

export const ProjectImageContainer = styled.div`
  width: 120px;
  height: 120px;
  flex-shrink: 0;

  @media (min-width: 640px) {
    width: 180px;
    height: 180px;
  }
`;

export const ProjectImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ProjectTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const ProjectDescription = styled.p`
  font-size: 14px;
  color: #4a5568;
  margin-bottom: 12px;
`;

export const ProjectMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: auto;
`;

export const ProjectMetaItem = styled.span`
  font-size: 12px;
  color: #718096;
`;

export const ProjectMetaLabel = styled.span`
  font-weight: 500;
`;

export const EditButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AddEventButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-top: 8px;
  border-top: 1px solid #e2e8f0;
`;

export const EditButton = styled.button`
  background-color: #4299e1;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #2d3748;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(74, 85, 104, 0.3);
  }
`;

export const AddEventButton = styled(EditButton)`
  background-color: ${pink.main};

  &:hover {
    background-color: ${pink[300]};
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(237, 100, 166, 0.3);
  }
`;

export const UserDropdown = styled(motion.div)`
  position: fixed;
  top: 70px;
  right: 20px;
  background-color: ${grayScale[100]};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 10;
  width: 160px;
`;

export const DropdownItem = styled.button`
  width: 100%;
  background-color: transparent;
  border: none;
  padding: 12px 16px;
  text-align: left;
  color: ${grayScale.white};
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${grayScale[200]};
  }

  &:active {
    background-color: ${grayScale[300]};
  }
`;
